import { connect } from 'react-redux';
import { selectors } from 'state/selectors';
import { mapStateToPropsSpinner } from './connectSpinner';
import { SpinnerOverlay } from './Spinner';
import { withQuoteId } from 'components/contexts';

export const TradeCaptureSpinner = withQuoteId(
  connect(mapStateToPropsSpinner(selectors))(SpinnerOverlay),
);
